import React from "react";
import "./WarningBanner.css";
import {cx} from "../lib/ClassSet";

const WarningBanner = (props) => {

  if (!props.show) return null;

  let classes = cx({
    "WarningBanner": true,
    "u-warn": props.error,
    "u-notice": !props.error
  })

  return (
    <div className={classes}>
      <div className="icon" />
      <div className="message">{props.message}</div>
    </div> 
  )

}

export default WarningBanner;

WarningBanner.defaultProps = {
  show: false,
  error: true,
  message: ""
}